import { render, staticRenderFns } from "./ProjectFields.vue?vue&type=template&id=07169fc2&lang=true&"
import script from "./ProjectFields.vue?vue&type=script&lang=js&"
export * from "./ProjectFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports